import CryptoJS from 'crypto-js';

export const encryptData = (value = {}) => {
    const { REACT_APP_CRYPTO_SECRET_KEY } = process.env;
    return CryptoJS.AES.encrypt(
      JSON.stringify(value),
      REACT_APP_CRYPTO_SECRET_KEY
    )?.toString();
  };
  
  export const decryptData = (data) => {
    try {
      if (!data) return {};
  
      const { REACT_APP_CRYPTO_SECRET_KEY } = process.env;
  
      const decryptedBytes = CryptoJS.AES.decrypt(
        data,
        `${REACT_APP_CRYPTO_SECRET_KEY}`
      );
      let test = decryptedBytes.toString(CryptoJS.enc.Utf8);
      return JSON.parse(test);
    } catch (e) {
      return {};
    }
  };


  export function queryStringToJSON(queryString = "") {
    // Remove the leading "?" if present in the query string
    if (queryString.startsWith("?")) {
      queryString = queryString.slice(1);
    }
  
    // Split the query string into key-value pairs
    const pairs = queryString.split("&");
  
    // Convert each pair into a key-value object
    const result = {};
    pairs?.forEach((pair) => {
      // Decode each key and value to handle encoded characters like "%3A"
      const [key, value] = pair.split("=").map(decodeURIComponent);
  
      // Convert string numbers to actual numbers in the result object
      result[key] = value;
    });
  
    return result;
  }
  